import { safeAttrValues } from "../attribute/safeAttrValues";
import { ZSafeValues } from "../attribute/ZAttrValue";
import { ZSpecification } from "../specification";
import { makeAttrMetaMap } from "../specification/makeAttrMetaMap";
import { ZClassRow, ZClassUnsafe } from "./ZClassRow";

export const makeClassRow = (
  rawData: ZClassUnsafe,
  schemes: ZSpecification[],
): ZClassRow => {
  const { data, ...common } = rawData;
  const safeData: ZClassRow["data"] = {};

  schemes.forEach((scheme) => {
    const unsafeAttrs = data[scheme.name];
    if (unsafeAttrs) {
      const safePart: ZSafeValues = safeAttrValues(
        unsafeAttrs,
        makeAttrMetaMap(scheme),
      );
      safeData[scheme.name] = safePart;
    }
  });

  const result: ZClassRow = {
    ...common,
    data: safeData,
  };
  return result;
};
